import React, { type ReactNode } from 'react';

import * as D from '../../../deps';

import './RecommendationsGrid.scss';

interface IRecommendationsGrid {
  items: [];
  title: ReactNode;
}

const RecommendationsGrid = (props: IRecommendationsGrid): $TSFixMe => {
  const { items, title } = props;

  return (
    <div className='RecommendationsGrid'>
      <div className='RecommendationsGrid__header'>{title}</div>
      <div className='RecommendationsGrid__list'>
        <D.Grid items={items} />
      </div>
    </div>
  );
};

export default RecommendationsGrid;
